<template>
    <div class="auth-wrapper">
        <div class="auth-box">
            <div class="lupus-logo">
                <router-link to="/login" tag="span" class="clickable">
                    <img src="@/../assets/lupus-logo.png" height="80px" alt="Lupus Logo" />
                </router-link>
            </div>
            <div class="title">
                <h4>Neues Passwort anfordern</h4>
            </div>
            <div v-if="processFinished" class="auth-form-container">
                <b-alert variant="success" show>
                    <b>E-Mail gesendet!</b>
                    Sie können diesen Tab jetzt schließen.
                </b-alert>
                <span></span>
            </div>
            <div v-else class="auth-form-container">
                <div class="auth-input-container">
                    <b-form-group
                        id="fieldset-email"
                        label="E-Mail"
                        description="Benötigt wird die E-Mail Adresse von Ihrem Lupus-Account."
                        label-for="input-email"
                    >
                        <b-form-input
                            id="input-email"
                            v-model="email"
                            v-validate="'required|email'"
                            name="email"
                            type="email"
                            placeholder="E-Mail Adresse"
                            :state="checkState('email')"
                        />
                    </b-form-group>
                </div>
                <div v-if="errors.any()" class="auth-error-message-container">
                    <span>{{ errors.all()[0] }}</span>
                </div>
            </div>
            <div class="auth-button-container">
                <div>
                    <button
                        class="btn btn-primary"
                        :disabled="errors.any() || !fieldIsDirty('email')"
                        @click="resetPassword"
                    >
                        Passwort anfordern
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ForgotPassword",
    data() {
        return {
            email: "",
            processFinished: false
        };
    },
    created() {},
    methods: {
        resetPassword: function() {
            this.$store
                .dispatch("sendResetPasswordMail", this.email)
                .then(() => {
                    this.processFinished = true;
                })
                .catch(() => {
                    //throw an error?
                });
        }
    }
};
</script>

<style scoped>
@import "login.css";
</style>
